var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165.028,
    height: 74.803,
    viewBox: "0 0 165.028 74.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_49",
    "data-name": "Clip 49",
    d: "M0,0H25.59V24.119H0Z",
    transform: "translate(0 0.027)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_60",
    "data-name": "Clip 60",
    d: "M0,0H15.949V19.943H0Z",
    transform: "translate(0.329 0.166)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0 -0.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WHOLESALE_2",
    "data-name": "WHOLESALE 2",
    transform: "translate(30.28 63.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WHOLESALE",
    d: "M37.934,11.481a6.359,6.359,0,0,1-4.162-1.541A5.525,5.525,0,0,1,31.9,5.732a5.5,5.5,0,0,1,1.868-4.193,6.4,6.4,0,0,1,8.325,0,5.5,5.5,0,0,1,1.868,4.193A5.527,5.527,0,0,1,42.1,9.941,6.362,6.362,0,0,1,37.934,11.481Zm0-9.547A3.86,3.86,0,0,0,35.341,2.95a3.733,3.733,0,0,0-1.174,2.817,3.767,3.767,0,1,0,7.533,0A3.762,3.762,0,0,0,37.934,1.934ZM5.075,11.379H3.767A38.077,38.077,0,0,1,0,.242H2.051a39.488,39.488,0,0,0,2.423,7.89H4.51c.5-1.214,2.028-6.155,2.44-7.89h1.84C9.2,1.988,10.812,6.966,11.3,8.115h.035A37.338,37.338,0,0,0,13.688.242h1.981c-.362,2.793-2.328,8.924-3.767,11.135H10.628A40.329,40.329,0,0,1,7.87,3.989H7.834a43.063,43.063,0,0,1-2.759,7.389Zm63.189,0a6.1,6.1,0,0,1-3.007-.742l-.229-2.123a5.588,5.588,0,0,0,3.183,1.036c1.107,0,1.822-.536,1.822-1.364s-.471-1.27-1.68-1.623c-2.106-.6-3.13-1.694-3.13-3.333C65.222,1.673,66.359.1,68.9.1a5.5,5.5,0,0,1,2.635.622L71.111,2.5a4.55,4.55,0,0,0-2.139-.6c-1.112,0-1.61.607-1.61,1.209,0,.633.451,1.029,1.557,1.364,2.311.706,3.342,1.8,3.342,3.539C72.26,10.119,70.766,11.378,68.264,11.378Zm-46.606-.12H19.43V.242h2.228V4.8h5.093V.242H28.98V11.256H26.753V6.665H21.658v4.593Zm55.118,0H74.583A40.116,40.116,0,0,1,78.987.121h1.256a39.5,39.5,0,0,1,4.4,11.136H82.453c-.189-.906-.427-1.825-.689-2.659H77.448c-.2.684-.491,1.7-.671,2.659Zm2.83-8.1a32.552,32.552,0,0,0-1.574,3.729H81.2A32.488,32.488,0,0,0,79.641,3.16Zm23.851,8.1H96.6V.242h6.3V2.055H98.806V4.817h3.4V6.647h-3.4v2.8h4.651v1.812Zm-9.256,0H87.358V.242h2.228v9.2H94.2v1.812Zm-31.214,0H56.126V.242h6.3V2.055H58.336V4.817h3.4V6.647h-3.4v2.8h4.651v1.812Zm-9.255,0H46.888V.242h2.228v9.2h4.616v1.812Z",
    fill: "#004e37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(63.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    "data-name": "Fill 22",
    d: "M4.9,2.458A2.451,2.451,0,1,1,2.45,0,2.455,2.455,0,0,1,4.9,2.458",
    transform: "translate(12.329 20.897)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_24",
    "data-name": "Fill 24",
    d: "M4.9,2.458A2.451,2.451,0,1,1,2.45,0,2.455,2.455,0,0,1,4.9,2.458",
    transform: "translate(23.324 10.808)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_26",
    "data-name": "Fill 26",
    d: "M5.811,5.247a6.723,6.723,0,0,1-2.906,5.247A6.723,6.723,0,0,1,0,5.247,6.723,6.723,0,0,1,2.905,0,6.723,6.723,0,0,1,5.811,5.247",
    transform: "translate(16.627 0.466)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_28",
    "data-name": "Fill 28",
    d: "M5.861,1.757A6.739,6.739,0,0,1,7.5,7.53,6.682,6.682,0,0,1,1.752,5.88,6.739,6.739,0,0,1,.108.109,6.681,6.681,0,0,1,5.861,1.757",
    transform: "translate(9.993 10.728)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_30",
    "data-name": "Fill 30",
    d: "M5.982.777a6.729,6.729,0,0,1,3.075,5.15,6.681,6.681,0,0,1-5.982-.1A6.726,6.726,0,0,1,0,.679a6.68,6.68,0,0,1,5.982.1",
    transform: "translate(0.232 15.677)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_32",
    "data-name": "Fill 32",
    d: "M5.908.347a6.717,6.717,0,0,1,3.92,4.535,6.675,6.675,0,0,1-5.907.944A6.713,6.713,0,0,1,0,1.292,6.681,6.681,0,0,1,5.908.347",
    transform: "translate(4.71 26.41)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_34",
    "data-name": "Fill 34",
    d: "M5.807,5.988A6.7,6.7,0,0,1,.963,9.512,6.742,6.742,0,0,1,.538,3.524,6.7,6.7,0,0,1,5.383,0a6.745,6.745,0,0,1,.423,5.988",
    transform: "translate(19.939 18.068)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_36",
    "data-name": "Fill 36",
    d: "M5.981,5.828A6.668,6.668,0,0,1,0,5.926,6.729,6.729,0,0,1,3.075.777a6.68,6.68,0,0,1,5.982-.1A6.729,6.729,0,0,1,5.981,5.828",
    transform: "translate(29.919 15.677)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_38",
    "data-name": "Fill 38",
    d: "M5.908,5.826A6.681,6.681,0,0,1,0,4.881,6.716,6.716,0,0,1,3.921.347a6.678,6.678,0,0,1,5.907.945,6.716,6.716,0,0,1-3.92,4.534",
    transform: "translate(24.728 26.415)",
    fill: "#fec10d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_55",
    "data-name": "Fill 55",
    d: "M5.95,2.985A2.975,2.975,0,1,1,2.975,0,2.981,2.981,0,0,1,5.95,2.985",
    transform: "translate(16.517 29.665)",
    fill: "#004e37"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_40",
    "data-name": "Fill 40",
    d: "M10.41,19.905C4.475,19.905,0,15.626,0,9.952S4.46,0,10.374,0c5.935,0,10.41,4.279,10.41,9.952S16.325,19.905,10.41,19.905Zm0-15A4.816,4.816,0,0,0,5.622,9.952a4.778,4.778,0,1,0,9.54,0A4.8,4.8,0,0,0,10.41,4.9Z",
    transform: "translate(28.131 37.288)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_42",
    "data-name": "Fill 42",
    d: "M5.3,19.06H.254A.255.255,0,0,1,0,18.8V.255A.255.255,0,0,1,.254,0H5.3a.255.255,0,0,1,.256.255V18.8a.256.256,0,0,1-.256.255",
    transform: "translate(79.763 37.711)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_44",
    "data-name": "Fill 44",
    d: "M10.41,19.905C4.475,19.905,0,15.626,0,9.952S4.461,0,10.376,0C16.31,0,20.785,4.279,20.785,9.952S16.325,19.905,10.41,19.905Zm0-15A4.816,4.816,0,0,0,5.622,9.952a4.778,4.778,0,1,0,9.541,0A4.8,4.8,0,0,0,10.41,4.9Z",
    transform: "translate(105.617 37.288)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_46",
    "data-name": "Fill 46",
    d: "M17.687,19.482H12.679a.256.256,0,0,1-.256-.255V8.3c0-2.3-.6-3.114-2.295-3.114A4.419,4.419,0,0,0,5.843,8.459a7.009,7.009,0,0,0-.291,2.231v8.536a.255.255,0,0,1-.254.255H.254A.255.255,0,0,1,0,19.227V.677A.255.255,0,0,1,.254.422H5.121a.254.254,0,0,1,.254.255V2.529A7.523,7.523,0,0,1,11.182,0c4.485,0,6.76,2.483,6.76,7.38V19.227a.255.255,0,0,1-.254.255",
    transform: "translate(128.851 37.289)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 32.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_49-2",
    "data-name": "Clip 49",
    d: "M0,0H25.59V24.119H0Z",
    transform: "translate(0 0.027)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50-2",
    "data-name": "Group 50",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_48",
    "data-name": "Fill 48",
    d: "M25.335,24.119h-5.1a.255.255,0,0,1-.254-.255c0-5.847-.448-12.482-.6-14.519a44.772,44.772,0,0,0-4.915,8.9.255.255,0,0,1-.234.154H11.362a.255.255,0,0,1-.234-.154,44.711,44.711,0,0,0-4.916-8.9c-.154,2.037-.6,8.673-.6,14.519a.256.256,0,0,1-.256.255H.256A.256.256,0,0,1,0,23.864C0,15.94.578,5.55,1.87.2A.253.253,0,0,1,2.117,0H6.155a.246.246,0,0,1,.189.087A45.313,45.313,0,0,1,12.8,9.56,45.386,45.386,0,0,1,19.245.087.253.253,0,0,1,19.435,0h4.038a.253.253,0,0,1,.247.2c1.292,5.352,1.87,15.744,1.87,23.669a.256.256,0,0,1-.256.255",
    transform: "translate(0 0.027)",
    fill: "#004e37"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_51",
    "data-name": "Fill 51",
    d: "M5.3,19.307H.256A.256.256,0,0,1,0,19.052V.5A.255.255,0,0,1,.256.247H5.122A.254.254,0,0,1,5.377.5V2.822A6.374,6.374,0,0,1,10.516,0a5.665,5.665,0,0,1,.7.048A.256.256,0,0,1,11.441.3v5a.259.259,0,0,1-.086.191.251.251,0,0,1-.2.063A7.319,7.319,0,0,0,10.27,5.5,4.531,4.531,0,0,0,5.913,8.886a9.08,9.08,0,0,0-.36,2.758v7.408a.256.256,0,0,1-.256.255",
    transform: "translate(51.621 37.464)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_53",
    "data-name": "Fill 53",
    d: "M5.3,19.307H.256A.256.256,0,0,1,0,19.052V.5A.255.255,0,0,1,.256.247H5.122A.254.254,0,0,1,5.377.5V2.821A6.376,6.376,0,0,1,10.516,0a5.665,5.665,0,0,1,.7.048A.256.256,0,0,1,11.441.3v5a.259.259,0,0,1-.086.191.244.244,0,0,1-.2.061A7.7,7.7,0,0,0,10.27,5.5,4.53,4.53,0,0,0,5.913,8.886a9.08,9.08,0,0,0-.36,2.758v7.408a.256.256,0,0,1-.256.255",
    transform: "translate(65.687 37.464)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_57",
    "data-name": "Fill 57",
    d: "M9.838,7.725l-.655-.205c-1.871-.583-3.03-.972-3.03-1.857V5.59c0-.748.83-1.223,1.946-1.212a9.834,9.834,0,0,1,4.419,1.36l.019.009a.249.249,0,0,0,.114.028.256.256,0,0,0,.23-.147l2.014-3.5a.247.247,0,0,0,.028-.115.252.252,0,0,0-.135-.223A13.72,13.72,0,0,0,8.216,0C3.617,0,.643,2.245.643,5.93V6c0,3.642,2.9,5.074,6.151,5.951.266.075.529.148.787.217,1.972.6,2.786,1.026,2.8,1.966v.071c-.078.737-.779,1.146-2.083,1.128a10.144,10.144,0,0,1-5.656-2.057l-.017-.011a.247.247,0,0,0-.139-.042.251.251,0,0,0-.212.115L.056,16.758A.247.247,0,0,0,0,16.916a.252.252,0,0,0,.116.213,12.916,12.916,0,0,0,7.8,2.812c5.032.014,8.038-2.227,8.038-6.152v-.071c0-3.522-3.045-5.052-6.111-5.993",
    transform: "translate(87.696 37.074)",
    fill: "#004e37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(148.75 36.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_60-2",
    "data-name": "Clip 60",
    d: "M0,0H15.949V19.943H0Z",
    transform: "translate(0.329 0.166)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61-2",
    "data-name": "Group 61",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_59",
    "data-name": "Fill 59",
    d: "M9.837,7.726c-.221-.071-.44-.138-.653-.205-1.871-.584-3.03-.973-3.03-1.857V5.592c0-.748.829-1.223,1.945-1.212a9.845,9.845,0,0,1,4.421,1.359l.019.01a.245.245,0,0,0,.114.028.252.252,0,0,0,.229-.147l2.015-3.5a.247.247,0,0,0,.028-.115.252.252,0,0,0-.135-.223A13.726,13.726,0,0,0,8.216,0C3.616,0,.642,2.245.642,5.931V6c0,3.642,2.9,5.074,6.151,5.951.267.075.53.147.787.216,1.972.6,2.786,1.026,2.8,1.967v.071c-.078.737-.781,1.146-2.084,1.126a10.137,10.137,0,0,1-5.655-2.057l-.017-.01a.241.241,0,0,0-.14-.042.251.251,0,0,0-.211.115L.056,16.758a.255.255,0,0,0,.06.373,12.932,12.932,0,0,0,7.8,2.812c5.032.014,8.038-2.227,8.038-6.152v-.071c0-3.522-3.045-5.053-6.113-5.993",
    transform: "translate(0.329 0.166)",
    fill: "#004e37"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login_logo.5d019739b6fb6154c30a4c247941b5f5.svg";
export { ForwardRef as ReactComponent };